__turbopack_context__.v({
  "column": "ApplyFormMeasurements-module__0lw67a__column",
  "columns": "ApplyFormMeasurements-module__0lw67a__columns",
  "container": "ApplyFormMeasurements-module__0lw67a__container",
  "fadeInItems": "ApplyFormMeasurements-module__0lw67a__fadeInItems",
  "field": "ApplyFormMeasurements-module__0lw67a__field",
  "fieldMetric": "ApplyFormMeasurements-module__0lw67a__fieldMetric",
  "fieldMetricActive": "ApplyFormMeasurements-module__0lw67a__fieldMetricActive",
  "fieldMetricButton": "ApplyFormMeasurements-module__0lw67a__fieldMetricButton",
  "inputWrapper": "ApplyFormMeasurements-module__0lw67a__inputWrapper",
  "selectGenderOptions": "ApplyFormMeasurements-module__0lw67a__selectGenderOptions",
  "selectInput": "ApplyFormMeasurements-module__0lw67a__selectInput",
  "selectOption": "ApplyFormMeasurements-module__0lw67a__selectOption",
  "selectOptions": "ApplyFormMeasurements-module__0lw67a__selectOptions",
  "spacing--lg": "ApplyFormMeasurements-module__0lw67a__spacing--lg",
  "spacing--md": "ApplyFormMeasurements-module__0lw67a__spacing--md",
  "spacing--sm": "ApplyFormMeasurements-module__0lw67a__spacing--sm",
  "spacing--xl": "ApplyFormMeasurements-module__0lw67a__spacing--xl",
  "spacing--xs": "ApplyFormMeasurements-module__0lw67a__spacing--xs",
  "spacing--xxl": "ApplyFormMeasurements-module__0lw67a__spacing--xxl",
  "spacing--xxs": "ApplyFormMeasurements-module__0lw67a__spacing--xxs",
  "spacing--xxxl": "ApplyFormMeasurements-module__0lw67a__spacing--xxxl",
  "spacing--xxxs": "ApplyFormMeasurements-module__0lw67a__spacing--xxxs",
  "text": "ApplyFormMeasurements-module__0lw67a__text",
  "title": "ApplyFormMeasurements-module__0lw67a__title",
});
